import { render, staticRenderFns } from "./MyQuestionnaires.vue?vue&type=template&id=0c877018"
import script from "./MyQuestionnaires.vue?vue&type=script&lang=js"
export * from "./MyQuestionnaires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports